import { addTelemetryUsage } from '../telemetry';
import { monitor } from '../../tools/monitor';
export function defineContextMethod(getStrategy, contextName, methodName, usage) {
  return monitor(function () {
    var _getStrategy$contextN;

    if (usage) {
      addTelemetryUsage({
        feature: usage
      });
    }

    return (_getStrategy$contextN = getStrategy()[contextName])[methodName].apply(_getStrategy$contextN, arguments);
  });
}
export function bufferContextCalls(preStartContextManager, name, bufferApiCalls) {
  preStartContextManager.changeObservable.subscribe(function () {
    var context = preStartContextManager.getContext();
    bufferApiCalls.add(function (startResult) {
      return startResult[name].setContext(context);
    });
  });
}